module.exports = __webpack_public_path__ + "img/banner-tablet.902c96a2.jpg";